import type { QualityConfig } from './vendor/config.js';
import type { QualityRuntimeConfig } from './types.js';

/**
 * mergeRuntimeConfig — pure helper for consumer-side threshold override (design D1).
 *
 * Merges runtime quality overrides (from db.settings.mi_quality_settings) with vendor
 * defaults to produce a single merged config passed to BOTH Gate A and Gate B.
 *
 * Only overridable fields (blur, brightness, face size) are merged; pose thresholds
 * (yaw/pitch) remain at vendor defaults.
 */
export function mergeRuntimeConfig(
  vendorDefaults: QualityConfig,
  runtimeConfig?: QualityRuntimeConfig,
): QualityConfig {
  if (!runtimeConfig) return vendorDefaults;

  return {
    ...vendorDefaults,
    ...(runtimeConfig.blurMinLaplacianVar !== undefined && { blurMinLaplacianVar: runtimeConfig.blurMinLaplacianVar }),
    ...(runtimeConfig.brightnessMin !== undefined && { brightnessMin: runtimeConfig.brightnessMin }),
    ...(runtimeConfig.brightnessMax !== undefined && { brightnessMax: runtimeConfig.brightnessMax }),
    ...(runtimeConfig.faceMinShortSidePx !== undefined && { faceMinShortSidePx: runtimeConfig.faceMinShortSidePx }),
  };
}
